"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var classes_1 = require("../../classes");
function isGenericDocument() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!value) return {
    isValid: true,
    message: ''
  };
  var stringfied = typeof value === 'string' ? value : String(value);
  var onlyNumbers = stringfied.replace(/\D/g, '');
  var noNumbers = stringfied.replace(/[0-9]/g, '');
  var hasMinimumChars = stringfied.length >= 6;
  var hasMoreNumbers = onlyNumbers.length > noNumbers.length;
  var isValid = hasMoreNumbers && hasMinimumChars;
  var message = isValid ? '' : 'Documento inválido';
  return new classes_1.ValidationResult(isValid, message);
}
exports.default = new classes_1.Validator(isGenericDocument);